import {ActionTree} from "vuex";
import {PriorityRuleItem, PriorityRulesState} from "@/store/settings/priority_rules/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<PriorityRulesState, RootState> = {
  getPriorityRules: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/set_priority`, params: data})
        .then(resp => {
          if (data?.page_number > 1) {
            commit('pushPriorityRules', resp.data?.priority_rules);
          } else {
            commit('setPriorityRules', resp.data?.priority_rules);
          }
          resolve(resp.data?.priority_rules)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPriorityRuleItem: ({commit, dispatch}, id: number) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/set_priority/${id}`})
        .then(resp => {
          let priorityRuleItem = <PriorityRuleItem>resp.data
          priorityRuleItem.id = id;
          commit('setPriorityRuleItem', priorityRuleItem);
          resolve(priorityRuleItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  savePriorityRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data?.id ? 'put' : 'post',
        url: `/acapi/set_priority/${data?.id ?? ''}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getPriorityRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePriorityRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/set_priority/${data.id}`
      })
        .then((resp:any) => {
          dispatch('getPriorityRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  setPriorityRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/acapi/set_priority/priority',
        data: data
      })
          .then((resp: any) => {
            dispatch('getPriorityRules', data);
            resolve(resp)
          })
          .catch((err: any) => {
            reject(err)
          })
          .finally(() => commit('setLoading', false));
    })
  }
}
